import { useCallback, useMemo, useState } from 'react'

import { type ImportMethod } from '../../models'
import { type ImportHandoffOption } from '../MethodView'
import { type SuntoryImportKind } from '../SuntoryImport'

/** 取り込み方法の画面に並べる、サントリー様の CSV の選択肢。kind で読み方と取り込み先が決まる。 */
export type ImportHandoff = ImportHandoffOption & {
  kind: SuntoryImportKind
}

/**
 * 取り込み方法の画面で、サントリー様の選択肢（handoff）の選択状態を持つ。
 * handoff を選んでいる間はこのモーダルの取り込み方法（method）より優先し、
 * method を選び直したら handoff の選択を外す。
 */
export const useImportHandoff = ({
  handoffs,
  onChangeMethod
}: {
  handoffs: readonly ImportHandoff[]
  onChangeMethod: (method: ImportMethod) => void
}) => {
  const [selectedHandoffKey, setSelectedHandoffKey] = useState<string | null>(
    null
  )

  const onChangeMethodClearingHandoff = useCallback(
    (method: ImportMethod) => {
      setSelectedHandoffKey(null)
      onChangeMethod(method)
    },
    [onChangeMethod]
  )

  const handoffOptions = useMemo<ImportHandoffOption[]>(
    () =>
      handoffs.map(({ key, title, description }) => ({
        key,
        title,
        description
      })),
    [handoffs]
  )

  const selectedKind =
    handoffs.find((h) => h.key === selectedHandoffKey)?.kind ?? null

  return {
    handoffOptions,
    selectedHandoffKey,
    selectedKind,
    onSelectHandoff: setSelectedHandoffKey,
    onChangeMethod: onChangeMethodClearingHandoff
  }
}
